import { TERMS_CONTENT } from "../config/terms-content.js";
import { TERMS_SCENE } from "../config/terms-scene.js";
import { legalHeaderMarkup } from "../components/legal-site-chrome.js";
import { escapeLegalText, termsDocumentSectionsMarkup, termsSectionDomId } from "../components/terms-document-markup.js";
import { createColdArchiveCompositor } from "../visuals/cold-archive-compositor.js";
import { createLegalWorldController, legalWorldMarkup } from "../visuals/legal-world-media.js";

function indexMarkup() {
  return TERMS_CONTENT.sections.map((section, index) => `
    <li><a href="#${escapeLegalText(termsSectionDomId("terms", section.id))}"><span>${String(index + 1).padStart(2, "0")}</span>${escapeLegalText(section.title)}</a></li>`).join("");
}

export function bootTermsReaderPage(app, { still = false } = {}) {
  document.body.dataset.page = "terms";
  document.title = "Exiled Systems — Terms of Service";
  app.innerHTML = `
    <div class="legal-experience legal-experience--archive">
      ${legalWorldMarkup({ still })}
      <canvas class="cold-archive-trail" data-cold-archive-trail aria-hidden="true"></canvas>
      <div class="legal-atmosphere" aria-hidden="true"></div>
      ${legalHeaderMarkup("terms")}
      <main class="legal-main" id="main-content">
        <section class="legal-hero" aria-labelledby="terms-title">
          <p class="legal-eyebrow"><i></i> POLICY ARCHIVE // EFFECTIVE VERSION 1</p>
          <h1 id="terms-title">${escapeLegalText(TERMS_CONTENT.title)}</h1>
          <p>${escapeLegalText(TERMS_CONTENT.summary)}</p>
          <p class="terms-reader-note"><i aria-hidden="true"></i><span><strong>Reading only.</strong> Viewing this page does not record agreement. When account creation is enabled, the exact effective policy and verified content hash will appear as the final signup checkpoint before any account request or verification email.</span></p>
          <dl>
            <div><dt>Status</dt><dd>${escapeLegalText(TERMS_CONTENT.status)}</dd></div>
            <div><dt>Version</dt><dd>${escapeLegalText(TERMS_CONTENT.version)}</dd></div>
            <div><dt>Revision</dt><dd>${escapeLegalText(TERMS_CONTENT.contentRevision)}</dd></div>
            <div><dt>Updated</dt><dd>${escapeLegalText(TERMS_CONTENT.lastUpdated)}</dd></div>
            <div><dt>Effective</dt><dd>${escapeLegalText(TERMS_CONTENT.effectiveDate)}</dd></div>
          </dl>
        </section>

        <div class="legal-workspace">
          <aside class="terms-index" aria-label="Terms sections">
            <p>DOCUMENT INDEX</p>
            <ol>${indexMarkup()}</ol>
            <button type="button" data-motion-toggle aria-pressed="false">Pause background</button>
            <button type="button" data-print>Print Terms</button>
          </aside>

          <article class="terms-document" aria-label="Effective Terms of Service Version 1">
            <div class="effective-policy-banner" role="note">
              <strong>IN EFFECT // VERSION 1</strong>
              <span>Effective July 24, 2026. This public reader records no acceptance. New-account acceptance remains unavailable until the separate Privacy Notice and every server-side registration gate are effective.</span>
            </div>
            ${termsDocumentSectionsMarkup(TERMS_CONTENT, { idPrefix: "terms", headingLevel: 2 })}
          </article>
        </div>
      </main>
      <footer class="legal-footer"><span>© 2026 EXILED SYSTEMS</span><span>${escapeLegalText(TERMS_CONTENT.policyId)} // ${escapeLegalText(TERMS_CONTENT.version)} // ${escapeLegalText(TERMS_CONTENT.contentRevision)}</span></footer>
    </div>`;

  const compositor = createColdArchiveCompositor(app.querySelector("[data-cold-archive-trail]"), { still });
  const world = createLegalWorldController(app, compositor, { still });
  app.querySelector("[data-print]").addEventListener("click", () => window.print());
  app.querySelector("[data-motion-toggle]").addEventListener("click", (event) => {
    const running = world.toggle();
    event.currentTarget.textContent = running ? "Pause background" : "Resume background";
    event.currentTarget.setAttribute("aria-pressed", String(!running));
  });

  window.__EXILED_TERMS__ = Object.freeze({
    ready: true,
    policyId: TERMS_CONTENT.policyId,
    version: TERMS_CONTENT.version,
    contentRevision: TERMS_CONTENT.contentRevision,
    materialChange: TERMS_CONTENT.materialChange,
    status: "effective",
    effective: TERMS_CONTENT.effective,
    readOnly: true,
    consentUi: false,
    acceptanceAvailable: false,
    registrationEnabled: false,
    mutationRequests: false,
    unresolvedDecisionCount: 0,
    launchPrerequisiteCount: TERMS_CONTENT.launchPrerequisites.length,
    scene: Object.freeze({ id: TERMS_SCENE.id, version: TERMS_SCENE.version, ...world.getState() }),
    compositor: compositor.getState(),
  });
}

